'use client';

import { type TransitionFunction, useTransition } from 'react';

import { BaseAction, type BaseActionProps } from './action';
import styles from './loadable.module.scss';
import LoaderIcon from '../icons/loader.svg';

export interface LoadableActionProps extends Omit<BaseActionProps, 'onClick'> {
  transition: TransitionFunction;
}

export function LoadableAction({ transition, children, ...props }: LoadableActionProps) {
  const [isPending, startTransition] = useTransition();

  return (
    <BaseAction {...props} onClick={() => startTransition(transition)}>
      {isPending ? <LoaderIcon className={styles.loader} /> : children}
    </BaseAction>
  );
}
